export default {
  // 統計信息
  total: "共計",
  totalData: "條數據",

  // 表格列標題
  asset: "資產",
  tokenContractAddress: "代幣合約地址",
  quantity: "數量",
  priceUSDT: "價格（USDT）",
  valueUSDT: "價值（USDT）",
  updateTime: "更新時間",

  // 提示信息
  priceTooltip: "代幣價格為當前幣種對應的USDT價格，價格數據每日更新",
  valueTooltip:
    "代幣價值是根據代幣價格計算得出，代幣價值受多種因素影響實時變化，此處代幣價值僅供參考",

  // 加載和狀態
  loading: "拼命加載中",
  noData: "暫無數據",
  tooMuchData: "當前地址交易數據過度，僅支持輸入發送方/接收方地址的條件查詢",

  // 下載
  downloadDetails: "下載數據明細",
  downloadNote: "注：最多可下載1萬條數據",
};
